/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
  Grid,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import clone from 'clone';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import { withTranslation } from 'react-i18next';

import InputBirthdate from '../../components/InputBirthdate';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

const fromMonth = moment().toDate();
const toMonth = new Date(fromMonth.getFullYear() + 1, fromMonth.getMonth(), fromMonth.getDate());

class LawyerAppointment extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appointment: PropTypes.shape({
      date_time: PropTypes.string,
      slot_1: PropTypes.string,
      slot_2: PropTypes.string,
      slot_3: PropTypes.string,
      remarks: PropTypes.string,
    }),
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    loading: PropTypes.bool,
  }
  static getPropsToState = (props) => {
    const oriAppointment = Object.assign({
      date_time: null,
      slot_1: null,
      slot_2: null,
      slot_3: null,
      remarks: '',
    }, props.appointment);
    const appointment = clone(oriAppointment);
    const hour = 12;
    const minute = 0;
    appointment.date_time = oriAppointment.date_time ? moment(oriAppointment.date_time) : null;
    appointment.slot_1 = oriAppointment.slot_1 ? moment(oriAppointment.slot_1) : moment();
    appointment.slot_2 = oriAppointment.slot_2 ? moment(oriAppointment.slot_2) : moment().add(1, 'days').set({ 'hour': hour, 'minute': minute });
    appointment.slot_3 = oriAppointment.slot_3 ? moment(oriAppointment.slot_3) : moment().add(2, 'days').set({ 'hour': hour, 'minute': minute });
    return {
      oriAppointment,
      appointment,
    };
  }
  constructor(props) {
    super(props);
    const state = LawyerAppointment.getPropsToState(props);
    this.state = {
      ...state,
    };
  }

  componentWillReceiveProps(nextProps) {
    const state = LawyerAppointment.getPropsToState(nextProps);
    if (state.oriAppointment !== this.state.oriAppointment) {
      this.setState(state);
    }
  }

  handleOnConfirm = (e) => {
    e.preventDefault();
    const { onConfirm } = this.props;
    if (onConfirm) {
      const { appointment } = this.state;
      const result = {};
      if (appointment.remarks) {
        result.remarks = appointment.remarks;
      }
      if (appointment.date_time) {
        result.date_time = appointment.date_time.format();
      } else {
        result.slot_1 = appointment.slot_1.format();
        result.slot_2 = appointment.slot_2.format();
        result.slot_3 = appointment.slot_3.format();
      }
      onConfirm(e, result);
    }
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnSlotChange = (day, idx) => {
    const { appointment } = this.state;
    appointment[`slot_${idx}`] = day;
    this.setState({ appointment });
  }
  handleOnRemarksChange = (e, { value }) => {
    const { appointment } = this.state;
    appointment.remarks = value;
    this.setState({ appointment });
  }
  handleOnDateChange = (day) => {
    const { appointment } = this.state;
    appointment.date_time = day;
    this.setState({ appointment });
  }
  handleMonthLogic = ({ year, month, currentYear, currentMonth }) => (year === currentYear && month < currentMonth)
  render() {
    const { loading, t } = this.props;
    const { appointment } = this.state;
    return (
      <Modal
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
      >
        <Header
          icon="calendar outline"
          content={t('Schedule appointment for Buyer and Lawyer')}
        />
        <Modal.Content>
          <Grid>
            {
              appointment.date_time ? (
                <Grid.Row>
                  <Grid.Column textAlign="left" mobile={16} tablet={4} computer={4}>
                    <Header as="h4">{t('Scheduled date')}</Header>
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={8} computer={8}>
                    <InputBirthdate
                      format={null}
                      date={appointment.date_time.format('YYYY-MM-DD')}
                      onSelectDay={this.handleOnDateChange}
                      disabled={loading}
                      fromMonth={fromMonth}
                      toMonth={toMonth}
                      monthLogic={this.handleMonthLogic}
                      disabledDays={{
                        before: moment().toDate(),
                      }}
                    />
                  </Grid.Column>
                  <Grid.Column mobile={6} tablet={4} computer={4} textAlign="right">
                    <TimePicker
                      use12Hours
                      showSecond={false}
                      value={appointment.date_time}
                      onChange={this.handleOnDateChange}
                      format="hh:mm a"
                      inputReadOnly
                      disabled={loading}
                      allowEmpty={false}
                    />
                  </Grid.Column>
                </Grid.Row>
              ) : Array(3).fill(3).map((d, idx) => (
                <Grid.Row key={idx}>
                  <Grid.Column textAlign="left" mobile={16} tablet={4} computer={4}>
                    <Header as="h4">{t('Slot {{number}}', { number: idx + 1 })}</Header>
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={8} computer={8}>
                    <InputBirthdate
                      format={null}
                      date={appointment[`slot_${idx + 1}`].format('YYYY-MM-DD')}
                      onSelectDay={day => this.handleOnSlotChange(day, idx + 1)}
                      disabled={loading}
                      fromMonth={fromMonth}
                      toMonth={toMonth}
                      monthLogic={this.handleMonthLogic}
                      disabledDays={{
                        before: moment().toDate(),
                      }}
                    />
                  </Grid.Column>
                  <Grid.Column mobile={6} tablet={4} computer={4} textAlign="right">
                    <TimePicker
                      use12Hours
                      showSecond={false}
                      value={appointment[`slot_${idx + 1}`]}
                      onChange={time => this.handleOnSlotChange(time, idx + 1)}
                      format="h:mm a"
                      inputReadOnly
                      disabled={loading}
                      allowEmpty={false}
                    />
                  </Grid.Column>
                </Grid.Row>
              ))
            }
          </Grid>
        </Modal.Content>
        <Modal.Actions style={{ justifyContent: 'center' }}>
          <Button
            primary
            onClick={this.handleOnConfirm}
            icon="checkmark"
            content={t('Confirm', { ns: TRANSLATION_FILES.translation })}
            disabled={loading}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(LawyerAppointment);



// WEBPACK FOOTER //
// ./src/containers/modals/LawyerAppointment.jsx